import { render, staticRenderFns } from "./SponsoredRecommendationPremiumImage.vue?vue&type=template&id=3febe1f2&scoped=true"
import script from "./SponsoredRecommendationPremiumImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationPremiumImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationPremiumImage.vue?vue&type=style&index=0&id=3febe1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3febe1f2",
  null
  
)

export default component.exports